<template>
  <b-container>
    <b-jumbotron v-if="!randomString" bg-variant="light">
      <div v-show="pageError.received">
        <h3>{{pageError.msg}}</h3>
        <hr class="my-4">
        <p>{{ $t('Register.invalidInvitePart1') }} <a href="mailto:smartdine@sylada.com">{{ $t('Register.invalidInvitePart2') }}</a> {{ $t('Register.invalidInvitePart3') }}</p>
      </div>
    </b-jumbotron>
    <b-card
      v-if="randomString"
      border-variant="danger"
      :header="$t('Register.header')"
      header-bg-variant="danger"
      header-text-variant="white"
      align="left"
      >
      <b-form @submit="onSubmit" autocomplete="off">
        <b-row class="my-1">
          <b-col class="pr-1">
            <b-form-input :placeholder="$t('Register.firstNamePlaceholder')" v-model="firstname" type="text"></b-form-input>
          </b-col>
          <b-col class="pl-1">
            <b-form-input :placeholder="$t('Register.lastNamePlaceholder')" v-model="lastname" type="text"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col>
            <b-form-input :placeholder="$t('Register.emailPlaceholder')" v-model="email" type="email"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col>
            <b-form-input :placeholder="$t('Register.passwordPlaceholder')" type="password"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col>
            <b-form-input :placeholder="$t('Register.confirmPasswordPlaceholder')" type="password"></b-form-input>
          </b-col>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-button variant="danger" type="submit">{{ $t('Register.registerButton') }}</b-button>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-alert :show="formError.received" variant="danger" class="text-center">{{formError.msg}}</b-alert>
        </b-row>
      </b-form>
    </b-card>
  </b-container>
</template>

<script>
/* CONTROLLER */
import AuthenticationService from '@/services/AuthenticationService'
import RegistrationLinkService from '@/services/RegistrationLinkService'
import { mapGetters } from 'vuex'

export default {
  name: 'Register',
  data () {
    return {
      firstname: '',
      lastname: '',
      email: '',
      randomString: '',
      formError: {
        received: false,
        msg: ''
      },
      pageError: {
        received: false,
        msg: ''
      }
    }
  },
  mounted () {
    // if already logged in, redirect to home page
    this.redirect()
    // check if link matches what's in the DB
    this.checkLink()
  },
  methods: {
    onSubmit (e) {
      e.preventDefault()
      this.register()
    },
    async register () {
      // clear out success alert in case it already exists
      this.regSuccesful = false

      try {
        const response = await AuthenticationService.register({
          firstname: this.firstname,
          lastname: this.lastname,
          email: this.email,
          password: document.querySelectorAll('input[type="password"]')[0].value,
          passwordconf: document.querySelectorAll('input[type="password"]')[1].value
        })
        // set store state for token and user
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)

        // redirect to home page, and send welcome message
        this.$router.push({
          name: 'StripeConnectStart',
          params: { msg: this.$i18n.t('Register.welcomeMsgPart1') + ' ' + this.firstname + '. ' + this.$i18n.t('Register.welcomeMsgPart2') }
        })
      } catch (error) {
        this.formError.received = true
        if (error.response.data.error === 'emailExists') {
          this.formError.msg = this.$i18n.t('Register.serverMessages.emailExists')
        } else {
          this.formError.msg = this.$i18n.t('Register.serverMessages.generic')
        }
      }
    },
    redirect () {
      let smartdineLocalStorage = JSON.parse(window.localStorage.getItem('smartdine'))

      if (this.isUserLoggedIn || smartdineLocalStorage.token) this.$router.push({ name: 'Home' })
    },
    async checkLink () {
      try {
        const response = await RegistrationLinkService.confirmLink(this.$route.params.randomstring)
        this.randomString = response.data.registrationLink.randomString
      } catch (error) {
        this.pageError.received = true
        this.pageError.msg = error.response.data.error
      }
    }
  },
  computed: {
    ...mapGetters({
      isUserLoggedIn: 'isUserLoggedIn'
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Register.vue